import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import Logo from '../../../Common/Logo'
import type { MenuSectionItemProps } from '../../../global-navigation'
import { hasNextLevel } from '../../../utils'

const MenuSectionItem = ({ item }: MenuSectionItemProps) => {
  return (
    <>
      <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
        <Logo logo={item.logoImage ?? ''} label={item.title ?? ''} />
        <div className="max-w-full overflow-hidden">
          <span
            style={{ color: item.titleColor ? item.titleColor : '#232323' }}
            className="flex gap-2 items-center text-sm font-semibold tracking-[0.035px]"
          >
            {item.title}
            {item.tag && (
              <span
                style={{ backgroundColor: item.tagColor ?? '' }}
                className={`rounded-sm text-white px-1 text-[9px] !leading-[14px] tracking-[-0.108px] font-[700]`}
              >
                {item.tag}
              </span>
            )}
          </span>
          {item.subtitle && (
            <span
              style={{
                color: item.subtitleColor ? item.subtitleColor : '#2C2C35',
              }}
              className="block text-xs font-[325] tracking-[-0.6px] max-w-full text-ellipsis overflow-hidden whitespace-nowrap"
            >
              {item.subtitle}
            </span>
          )}
        </div>
      </div>
      {hasNextLevel(item) && (
        <span className="block w-6 h-6">
          <ArrowRightGlobalNavigation />
        </span>
      )}
    </>
  )
}

export default MenuSectionItem
